module.exports = __webpack_public_path__ + "static/media/cavear-thumb.fa93f39e.jpg";